import utils from '../libs/utils';
import axios from './axios';

// 经营工具
export default {
  exportFile(params) { // 导出
    return axios.get(`/v1/erp-sys-web/sys/log/list/download?${utils.exchangeParams(params)}`);
  },
  getOperationHistoryList(params) { // 操作日志列表
    return axios.get(`/v1/erp-sys-web/sys/log/list?${utils.exchangeParams(params)}`);
  },
};
